import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { authReducer } from './_store/reducers';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from './_store/effects';
import { AuthApi } from './_api';
import { AuthService, SessionService, SessionGuard } from './_services';
import { SharedModule } from '@purplefront/shared';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('auth', authReducer),
    EffectsModule.forFeature([AuthEffects]),
    SharedModule
  ],
  providers: [AuthApi, AuthService, SessionGuard, SessionService]
})
export class AuthDataAccessModule {}
